import React from 'react';
import CarScanAiDocumentList from './CarScanAiDocumentList';

import { restrictUrls } from '../../../helpers/adminPrivileges';
import AdminLayout from '../../../components/Layout/AdminLayout';
export default async function action({params, store }) {

    const title = 'Car Scan AI Document List';
let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

if (!isAdminAuthenticated) {
  return { redirect: '/siteadmin/login' };
}

// // Admin restriction
// if (!restrictUrls('/siteadmin/carScanAiDocument', adminPrivileges, privileges)) {
//   return { redirect: '/siteadmin' };
// }
  const { reservationId } = params;
return {
  title,
  component: <AdminLayout><CarScanAiDocumentList title={title} reservationId={reservationId} /></AdminLayout>,
};
}




